import type { AppRouteRecordRaw } from '@/router/types'

/** 业务中台根路由：/business 或独立窗前缀 /ai-Application-center/business */
const BUSINESS_ROOT = /(^|\/)business\/?$/

/**
 * 业务中台侧栏补一个「APP配置」入口。
 *
 * 背景：C 端启动页/引导页/登录页文案与行业职位候选都在 `bosscircle_config.APP_COPY`
 * 里，管理端页面是 `views/business/app-copy/index.vue`，但 `system_menu` 里还没有这条
 * 菜单（权限点也没登记），所以侧栏看不到入口。
 *
 * 这里在前端菜单树里兜底插一条，保证运营能直接进；路由本身走
 * `router/modules/standalone-apps.ts` 里已注册的静态路由 `/business/app-copy`。
 * 之后若在「系统管理 → 菜单管理」正式加了同名菜单，这里的 `some` 判断会跳过，不会重复。
 */
export function appendBusinessMenus(routes: AppRouteRecordRaw[]): void {
  const extras = [
    {
      path: 'app-copy',
      name: 'BusinessAppCopyMenu',
      component: () => import('@/views/business/app-copy/index.vue'),
      meta: { title: 'APP配置', icon: 'ep:document' }
    },
    {
      path: 'red-packet',
      name: 'BusinessRedPacketMenu',
      component: () => import('@/views/business/red-packet/index.vue'),
      meta: { title: '红包配置', icon: 'ep:present' }
    }
  ] as AppRouteRecordRaw[]
  for (const root of routes) {
    if (!BUSINESS_ROOT.test(String(root.path || ''))) continue
    const children: AppRouteRecordRaw[] = root.children || (root.children = [])
    for (const extra of extras) {
      if (children.some((child) => String(child.path) === String(extra.path))) continue
      children.push({ ...extra })
    }
  }
}
